// extracted by mini-css-extract-plugin
module.exports = {"ArticleContent":"ArticleContent_ArticleContent_17L5r"};